module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct para-style-override-3",
    attrs: {
      "id": "toc_marker-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/There_Was_a_Crooked_Man2#Contents-A"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("The early summer days are long and sweet in Chicago. Dorrie Gillet was pruning her roses when Inga and I jogged over with my 8 by 10 glossies. Her gaze locked on the manila envelope in my hand and she began whacking the bush blindly. I was pretty sure I heard the roses screaming. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Whoa, Lorena Bobbit. Let go of the scissors.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She delivered a final, vicious blow before dropping the pruners and snatching the envelope from my hand. Bypassing the metal clasp, she shredded the envelope flap with trembling fingers. When she dragged the photos into the sunlight, she gave a strangled gasp.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The French chef’s head was buried in Elmer Fudd’s lap. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I spoke gently. “I’m sorry to say that Sheldon is…”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“—a dead man,” she hissed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I made sympathetic sounds with my tongue. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“That pig!” She waved a photo in my face. “Do you see that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I studied Sheldon’s ample body, glistening with sweat. He was an oinker, all right.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She followed my gaze and shoved the photo in my face. “I’m talking about "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("her")]), _vm._v("! The bitch stole my diamond ankle bracelet.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Seriously?")]), _vm._v(" I whipped out the Dr. Pepper Lip Smacker and smeared. I didn’t say Shelly was the sticky-fingered re-gifter. Inga pulled back on her leash, eyes wide with alarm. She wanted to make a break for it. I couldn’t blame her. The shearers were dangerously close. And the roses appeared terrified. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I kicked them under a lilac bush. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Dorrie’s voice broke. “Shelly gave me that diamond-heart anklet for my birthday. He was furious when I told him I’d lost it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I bit my tongue. Elmer Fudd was a self-serving, calculating douche bag. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Her raging eyes narrowed. “What happened to her, anyway? I know she didn’t go to prison. No woman on a jury would convict her.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Scissor lady. Lorena B.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Dorrie had the crazy eyes going. I steeled my own and held hers. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Firing squad. Scissor lady was a bloody mess.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Liar! You don’t want me to go off on the cheater!”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“That’s true. You’ve given him enough of your life. He doesn’t get any more.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Her voice oozed bitterness. “Shelly took the best years of my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“No way. Your best years are ahead of you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She looked deflated, as if the wind had been sucked out of her. Her eyes were on the ground, probably searching for her shearers. I put my hands on her shoulder and made her look at me. Then I gave her a good shake and released her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You’re not a victim. It’ll be tough at first but you’re smart. You’ll figure it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She gnawed her lip. “Can I call you sometime? I may need some advice.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Call anytime. I don’t have a lot of advice. I can only tell you what worked for me. Make a bucket list. Do everything you’ve dreamed of. Be gloriously happy. When you’re ready to date again, go out there and rock it. Living well is the best revenge.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She was quiet a long time. When she spoke again, her voice was clipped and strong. The old Dorrie was back. She had a plan. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She stuffed the pics back in my hands and dug the pruners out from under the lilacs. Inga and I took a cautious step back, poised to make a run for it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She gave a conspiratorial wink. “Keep these photos until I’m ready for them.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Oh-kay.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I want copies for Reverend Forgive-The-Shit. And for Shelly’s fellow deacons. His pissy mother. And for—hell, I’ll just make a list. I’ll e-mail pics to his staff at work. It’s more efficient, don’t you think?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Ouch. I actually felt sorry for Elmer Fudd. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Hell hath no fury…")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Dorrie Gillet gave a tender clip to her battered roses. “I need a little time. I have an expensive bucket list. And there are a few bank accounts to empty first.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You have my number.” ")]), _vm._v(" "), _c('p', {
    staticClass: "section"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("I woke the next morning to vague dreams of Elmer Fudd strung up by the neck over a bed of screaming roses. The dream put me in a funk that a hot shower and double espresso couldn’t touch. I grabbed Inga’s leash and we ran the dream into the ground. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We walked down South Halsted, breathing gratifying whiffs of dim sum, and churrasco, and chicken and waffles. Bridgeport offers some of Chicago’s best cuisine. It’s an orgy for the nose. Despite a bucket list that reads like a stack of travel brochures, there’s no place I’d rather come home to. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("My first stop was a funky shop that sells incense and those salt candles that are supposed to ward off negative spirits. I bought two large candles for my front porch on the off-chance they’d make my sister disappear. Our next stop was the bakery. I wanted to pick up a little something for my sister’s visit. I filled a white bag with a few donuts, fruit tarts, and anisette toast. Lemon tarts are Sophie’s favorite but she rarely indulges. When it comes to food, even chocolate doesn’t sing to her. She may not be fully human.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Sophie might be a twenty-nine-year-old baby factory but she looks like sweet-sixteen Barbie. She nibbles on rabbit food and tortures herself with Billy Blanks’ Boot Camp DVDs. She’s perpetually pregnant, or nursing, or both. I doubt she remembers the last time a nice red wine filled her glass. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Today was a rare moment in Sophie-world. My sister wasn’t pregnant and a baby wasn’t attached to her nipple. It was a flippin’ miracle and one she should celebrate with a spa day, a date night with her husband, and a pitcher of margaritas with her sister. I’d happily throw in a year’s supply of birth control. Even Barbie deserves a stiff drink and worry-free sex. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Sophie and I are polar opposites. We’re like night and day. Oil and water. A Kardashian afternoon. When we’re together, our time is strained at best. It’s not rocket-science to understand why. We share no genes. My alleged sister, Sophia Maria DeLuca, was switched at birth.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Here are the facts.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I’m tall like my brothers and I adore Serena Williams. Sophie’s short and disapproves of women sweating in public. I climbed trees when we were kids. Sophie had a gazillion dolls and she cut holes in their lips to force-feed them. She gave them baths. The day I held Rosie under water, Sophie sobbed. In my defense, I was five and thought her dolls had superpowers. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The last thing Sophie and I had in common was diapers. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Inga and I breezed out of the bakery with goodies in hand. Across the street, a woman outside Baumgarten Jewelry caught my eye. Something about her intrigued me. At first I thought it was her green scarf, covering her red hair. A Hermès original and deliciously gorgeous. She wore a butterscotch leather jacket and her diamond earrings blinged in the sun. She appeared fascinated with a window display of teardrop diamond necklaces. But her posture was too attentive for a dreamy necklace gape. She was on high alert, aware of everything around her. In the window’s reflection, I caught her eyes sweep the street behind her. That’s when I knew what drew me to her. She was me. Or more accurately, PI Cat DeLuca in surveillance mode. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The woman in green was a professional. A private investigator. An undercover Fed. A government spy. Or even a thief. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Cops and robbers have a lot more in common than you may think.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She seemed to intuit my radar on her and stiffened almost imperceptibly. Her eyes found me in the glass. I smiled and knelt beside Inga, fussing with her collar. She resumed her bogus fascination with the necklaces in the window.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("And then my eyes hooked a real skulker and I forgot about the woman in green. He was behind the wheel of a parked Lexus. A hand half-covered his face and he hunkered down in his seat as if willing himself invisible. His shoulders sagged. His right tires flanked a fire hydrant. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("He was a picture of doom. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I patted Inga’s head. “We’re going in, girl. Somebody needs a donut.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We hoofed it to the man’s car unobserved. I whipped open the passenger door and hopped inside. Inga clambered over my lap and into the backseat. I dropped the gift bag at my feet and the bakery bag on my lap.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Why so bummed, Bobby boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Captain Bob flinched and blew a sigh. I’d startled him. And he’s a tough guy. He’s not one to get rattled.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Christ, Cat.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Bob Maxfield is Captain of Bridgeport’s Ninth Precinct. I had few illusions that he’d be happy to see me. Even on a good day, he forgets how much he loves me. And this was clearly not a good day. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("A few decades ago, Bob and Papa were partners, cruising the streets of Bridgeport. Their careers took different paths but they’ve remained close. Bob is family. He’s attended every important milestone in my life. And now he’s like the codgy old uncle who hates what I do. Bob is a cop snob. He disrespects private investigators and he calls me a hootchie stalker. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("And yet, I bring him donuts. I need therapy.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I glanced at Bob’s laptop, open on his lap. A blond Pomeranian cowered on the screen, captive in an unforgiving metal cage. His big brown eyes were pleading. He could’ve been on death row. A cardboard sign propped beside the cage had something scrawled in black marker. September 19, 1999. I thought it was a photo until the little guy blinked. He was on live feed.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Bob slammed the laptop shut. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I caught my breath. “That was Sam I Am.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You didn’t see that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Your dog is in that horrible cage. What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“None of your business. Get out of my car.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“My God, Captain. Did some monster kidnap your dog?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Inga whimpered in the backseat.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Go away, Cat. I got this.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You don’t got shit, Bob. Cuz you don’t have Sam.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I can’t hear you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Who knows about this?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Peggy’s in Connecticut. Her sister had surgery.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You’re not alone anymore. You have me now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("He choked a little.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I’m a trained investigator, Bob. I’ll get Sammy back.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You’re a hootchie stalker.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“That hurt, Bob, but I’ll let it slide. You’re in shock.” I opened the white bag and held it for him. “Have a donut.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("He scooped up the entire bag, peered inside and frowned. “No lemon crèmes?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Lemon tarts.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“That works.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("He dragged out a tart and a bear claw and placed them both on the dash. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Coffee?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“At my house.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I reached over the console to grab a donut for myself. Bob closed the bag and stuffed it between him and the door.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You should’ve brought coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“How much do they want for Sam I Am?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“They haven’t made any demands yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“If it’s not money they want, why did they take him?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Again, none of your business.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The glob of lemon curd on Bob’s nose was disturbing. I tried not to stare. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“September 19th, 1999. What does that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Bob’s face twitched and the lemon jiggled. “I don’t know.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Do not try to play poker.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The lemon tart was history. He chomped into the bear claw.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I bet Papa remembers. You two were partners then.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Do not involve Tony.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Why do I have a feeling he’s already involved?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Suddenly Bob looked old and tired. “God, you’re irritating. Go away before I have you arrested.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You have to trust somebody. If you don’t want to talk to me, talk to my brother, Rocco. He’s a DeLuca. He’ll take your secret to the grave with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Bob shook his head and his jowls wobbled. “I won’t involve my men. If this goes south, I’m not taking Rocco down with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You’re making a big mistake, Bob. Huge.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("My eyes wandered across the street. The woman in green had moved inside the jewelry store. The proprietor whipped out a black velvet cloth and laid out a tempting selection of diamond necklaces on the counter. I whipped out my pocket spy-eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Bob blew an exaggerated sigh. “My God, Caterina. You’re incurable.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I’m a professional, Captain. We’re in the same business.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("He gave a hoot. “When pigs fly.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The woman carefully selected a necklace from the counter and handed it to the jeweler. She unbuttoned her leather jacket exposing a long neck and plunging neckline. Push-up bra on steroids. The jeweler ogled appreciatively and stepped behind her. She whipped up her long red hair, holding it on top of her head as he fastened the necklace. As she lowered her hands, a deft finger snared a necklace from the counter. In one fell swoop, it dropped neatly into her pocket. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She fingered her hair and flashed a flirtatious smile at the jeweler. He grinned like an adolescent boy and produced a mirror. They studied the diamonds and sapphires blinging on her breasts. She sighed deeply and gave a regretful shake of her head. Woman in Green wasn’t buying the necklace.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Oh my God, Bob. Did you see that? That woman just stole a diamond necklace.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I doubt that very much.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“It’s in her pocket. I saw her take it with my eyes. Captain! Arrest her.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You arrest her. Leave me alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You’d like that, wouldn’t you?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("There was a rap on the window and one of Bridgeport’s finest bellowed through the glass. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Move it, buddy. You’re illegally parked beside a fireplug.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Captain Bob lowered the window and the officer gulped. “Uh, sorry, Captain. I didn’t recognize you, sir.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Tommy is a rookie from Wisconsin. He and I became fast friends his first day on the job, when a little explosion in my car almost killed him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Tommy’s gaze drifted to me. Back to Bob’s growly face. And to me again. His eyes blinked.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Sir, is there something I can help you with?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Yes, Officer,” Captain Bob barked. “Go around to Ms. DeLuca’s door and remove her from my car. With force, if necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Force, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You have a gun, don’t you? I’ll give you a donut if you shoot her.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Inga and I didn’t take our chances. We tumbled onto the sidewalk without assistance. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I poked my head back in the car. “We’ll talk tonight, Captain.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“No, we won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I lowered my voice to a whisper. “And don’t worry about your boy. I’ll get him back before Sam I Am becomes Sam I Was.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-826fb8aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/There_Was_a_Crooked_Man-7.vue
// module id = 78
// module chunks = 0